import React, { ComponentType, Fragment } from 'react';
import { createStyles, withStyles } from '@material-ui/core/styles';

import * as paths from 'paths';
import * as LayoutComponents from './Components';

const styles = () =>
  createStyles({
    '@global html, body, #root': {
      height: '100%',
    },
  });

export const OnboardingWrapper: ComponentType = withStyles(styles)(({ children }) => (
  <Fragment>{children}</Fragment>
));

export const onboardingRoutes = [
  { path: paths.onboardingProfile, component: LayoutComponents.OnboardingProfileLayout },
  { path: paths.onboardingFollows, component: LayoutComponents.OnboardingFollowsLayout },
];
